/**
 * @file AbaStaffingFlorida.jsx
 * @description Agency market page at /aba-staffing-florida. Statewide page: South Florida framed as strongest coverage, the rest of the state as growing. Layout lives in
 *   AgencyMarketPage; this file owns the SEO head, breadcrumb JSON-LD and the
 *   page's copy/visual config (agencyMarket.florida.* keys).
 * @module components/AbaStaffingFlorida
 */
import { useTranslation } from "react-i18next";
import { agencyChips } from "./AgencyVisuals";
import AgencyMarketPage from "./AgencyMarketPage";
import { useBreadcrumbJsonLd, useSiteSchema } from "../lib/seoSchema";
import { usePageSeo } from "../lib/seo";

export default function AbaStaffingFlorida({ onNavigate }) {
  const { t } = useTranslation();
  const k = (key) => t(`agencyMarket.florida.${key}`);

  usePageSeo({
    title: "ABA Staffing in Florida | Reach RBTs, BTs, BCBAs, and ABA Therapists",
    description: "ABA agencies in Florida can use ABAcases to reach RBTs, BTs, BCBAs, BCaBAs, and ABA therapists by market, role, schedule, credential, and setting.",
    canonical: "/aba-staffing-florida",
  });
  useSiteSchema(); // global Organization + WebSite
  useBreadcrumbJsonLd("bc-jsonld-aba-staffing-florida", [
    { name: "Home", url: "/" },
    { name: "For ABA Agencies", url: "/aba-agencies" },
    { name: "ABA Staffing in Florida", url: "/aba-staffing-florida" },
  ]);

  return (
    <AgencyMarketPage
      onNavigate={onNavigate}
      source="aba_staffing_florida"
      pagePath="/aba-staffing-florida/"
      market="florida"
      crumb={k("title")}
      badge={k("badge")}
      title={k("title")}
      subtitle={k("subtitle")}
      chips={agencyChips(t)}
      coverageTitle={k("coverageTitle")}
      body={k("body")}
      visual={{ type: "regions", regions: t("agencyMarket.florida.regions", { returnObjects: true }) || [] }}
      area={k("area")}
      links={[
        { to: "rbt-staffing-miami-fl", label: t("agencyMarket.linkMiami") },
        { to: "aba-staffing-for-small-agencies", label: t("agencyMarket.linkSmall") },
        { to: "post-aba-cases", label: t("agencyMarket.linkPost") },
      ]}
    />
  );
}
